import { useMemo } from "react";
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList"
import { FormProjetoHibridoType } from "src/store/vendas/projetos/hibrido/hibrido.types";
import { InputPrefix } from "./InputPrefix"

interface TensaoSaidaInputProps {
  errorState: string[];
  formState: FormProjetoHibridoType;
  onChangeValue: (formState: Partial<FormProjetoHibridoType>) => void;
}

export const TENSAO_SAIDA_OPTIONS = [
  {
    id: 1,
    nome: '220V'
  },
  // {
  //   id: 2,
  //   nome: '220/380V'
  // },
];

export const TensaoSaidaInput = ({ errorState, formState, onChangeValue }: TensaoSaidaInputProps) => {
  return (
    <InputComboBoxList
      id={"hibrido-tensao-saida-field"}
      key={`hibrido-tensao-saida-field`}
      label={"* Tensão de Saída (V)"}
      textField="nome"
      //prefix={<InputPrefix />}
      valueField="id"
      disableClearable
      options={TENSAO_SAIDA_OPTIONS}
      disabled={TENSAO_SAIDA_OPTIONS.length === 1}
      value={formState?.tensao_saida || null}
      renderOptions={(option: any) => {
        return `${option?.nome}`
      }}
      renderOptionsLabel={(option: any) => {
          return `${option?.nome}`
        }}
      onChange={(value) => {
        const payload: Partial<typeof formState> = { tensao_saida: value };

        onChangeValue(payload)
      }}
    />
  )
}